import React from 'react';
export var Context = React.createContext({
  selectedValue: '',
  onChange: function onChange() {},
  name: ''
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Radio/context.js
// module id = 396
// module chunks = 0